export default "__VITE_ASSET__BIPwNpRf__"